import axios from 'axios';

export const baseURL = 'https://staging.backend.carchaser.ca/api';
export const baseImageUrl = `https://staging.backend.carchaser.ca/uploads/`;
export const baseVideoUrl = "https://staging.backend.carchaser.ca/videos/";

const api = axios.create({
  baseURL: 'https://staging.backend.carchaser.ca/api', // Base URL for all requests
  timeout: 10000, // Timeout for requests (optional)
});

// Response interceptor for handling errors globally
api.interceptors.response.use(
  (response) => {
    // If the response is successful, simply return the data
    return response;
  },
  async (error) => {
    const { response, config } = error;

    // Handle "429 Too Many Requests" globally
    if (response && response.status === 429) {
      const retryAfter = response.headers['retry-after'] || 1; // Retry-After header or default to 1 second
      console.warn(`Rate limit reached. Retrying after ${retryAfter} seconds...`);

      // Wait for the specified time before retrying
      await new Promise((resolve) => setTimeout(resolve, retryAfter * 1000));

      // Retry the original request
      return api(config);
    }

    // Reject the promise if it's another type of error
    return Promise.reject(error);
  }
);

export default api;
